import React, { useEffect, useState } from "react";
import { CiMenuBurger } from "react-icons/ci";
import { IoMdClose } from "react-icons/io";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { API_URL_AUTH, API_REFRESH } from "../../config";
import axios from "axios";
import jwtDecode from "jwt-decode";
import logo from "../../assets/images/logo.webp";

const Navbar = () => {
  const [isProfileOpen, setIsProfileOpen] = useState(false); // State untuk dropdown profil
  const [isOpen, setIsOpen] = useState(false); // State untuk mobile menu
  const [token, setToken] = useState("");
  const [expire, setExpire] = useState("");
  const [kesatuan, setKesatuan] = useState(null);
  const [fotoUser, setFotoUser] = useState(null);
  const [namaUser, setNamaUser] = useState(null);

  const location = useLocation();
  
  const toggleProfileMenu = () => setIsProfileOpen(!isProfileOpen);
  const toggleMenu = () => setIsOpen(!isOpen);

  const navigate = useNavigate();

  const handleLogOut = () => {
    Swal.fire({
      title: "Keluar?",
      text: "Apakah anda yakin, akan keluar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Iya, Keluar!",
      cancelButtonText: "Kembali",
    }).then((result) => {
      if (result.isConfirmed) {
        refreshToken();
        localStorage.clear();
        sessionStorage.clear();
        const cookies = document.cookie.split("; ");

        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i];
          const eqPos = cookie.indexOf("=");
          const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          document.cookie =
            name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;";
        }
        navigate("/login");
      }
    });
  };

  const refreshToken = async () => {
    const token = localStorage.getItem("refToken");

    try {
      const response = await axios.post(`${API_REFRESH}`, { token: token });
      setToken(response.data.token);
      handleLogOutUser(response.data.token);
      const decoded = jwtDecode(response.data.token);
      setExpire(decoded.exp);
    } catch (error) {
      if (error.response) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false,

          // willClose: () => {
          //     navigate("/login");
          // },
        }).then((result) => {
          if (result.dismiss === Swal.DismissReason.timer) {
            navigate("/login");
          }
        });
      }
    }
  };

  const api = axios.create();

  api.interceptors.request.use(
    async (config) => {
      const currentDate = new Date();
      if (expire * 1000 < currentDate.getTime()) {
        const response = await axios.post(`${API_REFRESH}`, { token: token });
        config.headers.Authorization = `Bearer ${response.data.token}`;
        setToken(response.data.token);
        const decoded = jwtDecode(response.data.token);
        setExpire(decoded.exp);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  const handleLogOutUser = async (token) => {
    axios
      .delete(`${API_URL_AUTH}/mopsimapp/logout?token=${token}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const { message } = response.data;
        Swal.fire({
          icon: "success",
          title: "Success",
          text: message,
          showCancelButton: false,
          showConfirmButton: false,
          timer: 1500,
        });
        navigate("/login");
      })
      .catch((error) => {
        const { data } = error.response;
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.message,
          showCancelButton: false,
        });
      });
  };

  useEffect(() => {
    const raw = localStorage.getItem("refToken");
    if (raw) {
      try {
        const decoded = jwtDecode(raw);
        const userData = decoded.rows?.[0];
        setFotoUser(userData?.fotoUser || "Tidak ada foto");
        setNamaUser(userData?.namaUser || "Tidak ada nama");
        setKesatuan(userData?.kesatuan || "-");
      } catch (err) {
        console.error("Gagal decode token:", err);
      }
    }
  }, []);

  return (
    <nav className="bg-teal-800 shadow-md">
      <div className="container mx-auto flex justify-between items-center px-4 py-3 md:py-4">
        {/* Logo Section */}
        <div className="items-center gap-2 hidden md:flex">
          <Link to="/" className="flex items-center gap-2">
            <img 
              src={logo} 
              alt="Logo Monitoring" 
              className="h-10 w-auto" 
            />
          </Link>
        </div>

        {/* Hamburger Menu for Mobile */}
        <div className="md:hidden">
          <button
            onClick={toggleMenu}
            className="text-white focus:outline-none focus:ring-2 focus:ring-gray-400"
          >
            {isOpen ? <IoMdClose size={28} /> : <CiMenuBurger size={28} />}
          </button>
        </div>

        {/* Navigation Links */}
        <div
          className={`absolute inset-x-0 top-14 bg-teal-800 md:static md:bg-transparent md:flex md:items-center md:space-x-6 ${isOpen ? "block" : "hidden"
            }`}
        >
          <ul className="flex flex-col md:flex-row items-start md:space-x-2 py-2 md:py-0">
            <li className="w-full md:w-auto">
              <Link
                to="/"
                className={`block py-2 px-4 rounded-full transition-all duration-200 text-center md:text-left ${
                  location.pathname === "/"
                    ? "bg-gradient-to-r from-amber-600 to-amber-700 text-white font-bold shadow-md"
                    : "text-white hover:bg-amber-700/40"
                }`}
                onClick={() => setIsOpen(false)}
              >
                Home
              </Link>
            </li>
            <li className="w-full md:w-auto">
              <Link
                to="/outlet"
                className={`block py-2 px-4 rounded-full transition-all duration-200 text-center md:text-left ${
                  location.pathname === "/outlet"
                    ? "bg-gradient-to-r from-amber-600 to-amber-700 text-white font-bold shadow-md"
                    : "text-white hover:bg-amber-700/40"
                }`}
                onClick={() => setIsOpen(false)}
              >
                Rekap Outlet
              </Link>
            </li>
            <li className="w-full md:w-auto">
              <Link
                to="/sim"
                className={`block py-2 px-4 rounded-full transition-all duration-200 text-center md:text-left ${
                  location.pathname === "/sim"
                    ? "bg-gradient-to-r from-amber-600 to-amber-700 text-white font-bold shadow-md"
                    : "text-white hover:bg-amber-700/40"
                }`}
                onClick={() => setIsOpen(false)}
              >
                Rekap Jenis SIM
              </Link>
            </li>
            <li className="w-full md:w-auto">
              <Link
                to="/laporan"
                className={`block py-2 px-4 rounded-full transition-all duration-200 text-center md:text-left ${
                  location.pathname === "/laporan"
                    ? "bg-gradient-to-r from-amber-600 to-amber-700 text-white font-bold shadow-md"
                    : "text-white hover:bg-amber-700/40"
                }`}
                onClick={() => setIsOpen(false)}
              >
                Laporan
              </Link>
            </li>
            <li className="w-full md:w-auto">
              <Link
                to="/atensi"
                className={`block py-2 px-4 rounded-full transition-all duration-200 text-center md:text-left ${
                  location.pathname === "/atensi"
                    ? "bg-gradient-to-r from-amber-600 to-amber-700 text-white font-bold shadow-md"
                    : "text-white hover:bg-amber-700/40"
                }`}
                onClick={() => setIsOpen(false)}
              >
                Atensi
              </Link>
            </li>
          </ul>
        </div>

        {/* Profil User */}
        <div className="relative">
          <button
            onClick={toggleProfileMenu}
            className="text-white flex items-center gap-3"
          >
            <div className="flex flex-col items-end mr-2">
              <span className="text-xs md:text-sm font-semibold">{namaUser}</span>
              <span className="text-[10px] md:text-xs opacity-80">{kesatuan}</span>
            </div>
            <img src={fotoUser} alt="profile" className="w-7 md:w-8 h-7 md:h-8 rounded-full cursor-pointer border border-white" />
          </button >
          {/* Dropdown menu for profile */}
          {
            isProfileOpen && (
              <div className="absolute right-0 mt-2 bg-white text-gray-700 rounded-lg shadow-lg w-48">
                <div className="px-4 py-3 border-b border-gray-200">
                  <p className="font-semibold">{namaUser}</p>
                  <p className="text-xs text-gray-600">{kesatuan}</p>
                </div>
                <ul className="py-2">
                  <li>
                    <a
                      href="/#"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-200"
                    >
                      Profile
                    </a>
                  </li>
                  <li>
                    <a
                      href="/#"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-200"
                      onClick={() => handleLogOut()}
                    >
                      Logout
                    </a>
                  </li>
                </ul>
              </div>
            )
          }
        </div >
      </div >
    </nav >
  );
};

export default Navbar;
